import { useForm, type FieldValues, type Path, type UseFormProps, type UseFormReturn } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import type { z, ZodTypeAny } from "zod";
import { toast } from "sonner";
import { ApiError } from "./api";

/** react-hook-form + zod: a submit a séma kimeneti (alapértékekkel kitöltött) típusát kapja. */
export function useZodForm<S extends ZodTypeAny>(schema: S, props?: Omit<UseFormProps<z.input<S>, unknown, z.output<S>>, "resolver">) {
  return useForm<z.input<S>, unknown, z.output<S>>({ resolver: zodResolver(schema), mode: "onTouched", ...props });
}

/** A szerver mezőszintű hibáit a formra teszi, a többit toastban mutatja. */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function handleFormError<T extends FieldValues>(form: UseFormReturn<T, any, any> | null, err: unknown) {
  if (err instanceof ApiError) {
    if (form && err.fields && Object.keys(err.fields).length) {
      for (const [k, v] of Object.entries(err.fields)) if (v) form.setError(k as Path<T>, { message: v });
      return;
    }
    toast.error(err.message);
    return;
  }
  toast.error("Valami félrement. Próbáld újra!");
}

export function toastError(err: unknown) {
  handleFormError(null, err);
}
